<app-compatibility-card id="opticalSensorTutorial">
  <h3>{{ "compatibility.opticalSensor.tutorial.title" | translate }}</h3>
  <h4>
    {{ "compatibility.opticalSensor.tutorial.subtitle" | translate }}
  </h4>

  <div class="tuto">
    <div class="tuto-step">
      <div class="image-container">
        <img
          [src]="'assets/images/compatibility/optical-sensor-mobile-1.png'"
          [alt]="'phone 1'"
          class="step-image"
        />
        <img
          src="assets/images/compatibility/mobile-pointer.png"
          alt="optical-sensor"
          class="mobile-pointer step1"
        />
      </div>
      <p class="step-text">
        {{ "compatibility.opticalSensor.tutorial.step1.part1" | translate }}
        <span class="bold">{{
          "compatibility.opticalSensor.tutorial.step1.part2" | translate
        }}</span
        >{{ "compatibility.opticalSensor.tutorial.step1.part3" | translate }}
        <span class="bold">{{
          "compatibility.opticalSensor.tutorial.step1.part4" | translate
        }}</span>
      </p>
    </div>

    <div class="tuto-step">
      <div class="image-container">
        <img
          [src]="'assets/images/compatibility/optical-sensor-mobile-2.png'"
          [alt]="'phone 2'"
          class="step-image"
        />
        <img
          src="assets/images/compatibility/mobile-pointer.png"
          alt="optical-sensor"
          class="mobile-pointer step2"
        />
      </div>
      <p class="step-text">
        {{ "compatibility.opticalSensor.tutorial.step2.part1" | translate }}
        <span class="bold">{{
          "compatibility.opticalSensor.tutorial.step2.part2" | translate
        }}</span>
      </p>
    </div>

    <div class="tuto-step">
      <div class="image-container">
        <img
          [src]="'assets/images/compatibility/optical-sensor-mobile-3.png'"
          [alt]="'phone 3'"
          class="step-image"
        />
        <img
          src="assets/images/compatibility/mobile-pointer.png"
          alt="optical-sensor"
          class="mobile-pointer step3"
        />
      </div>
      <p class="step-text">
        {{ "compatibility.opticalSensor.tutorial.step3" | translate }}
      </p>
    </div>

    <div class="tuto-step">
      <div class="image-container">
        <img
          [src]="'assets/images/compatibility/optical-sensor-mobile-4.png'"
          [alt]="'phone 4'"
          class="step-image"
        />
        <img
          src="assets/images/compatibility/mobile-pointer.png"
          alt="optical-sensor"
          class="mobile-pointer step4"
        />
      </div>
      <p class="step-text">
        {{ "compatibility.opticalSensor.tutorial.step4.part1" | translate }}
        <span class="bold">{{
          "compatibility.opticalSensor.tutorial.step4.part2" | translate
        }}</span>
      </p>
    </div>
  </div>
</app-compatibility-card>
